import Repository from './Repository.js';

class DocumentsRepository extends Repository {
    async downloadDocuments(body) {
        return await this.download('documents/download', body);
    }

    async deleteDocument(documentId) {
        return await this.delete(`documents/${documentId}`);
    }

    async uploadDocument(input) {
        const body = new FormData();

        for (const key in input) {
            const value = input[key];
            if (Array.isArray(value)) {
                for (const val of value) {
                    body.append(key, val);
                }
            } else {
                body.append(key, value);
            }
        }

        return await this.post('documents', body, false);
    }
}

export default new DocumentsRepository();
